export default __webpack_public_path__ + "static/media/21.84df3081.png";